import { Link } from 'react-router-dom'
import logo from '../../assets/decida_logo_light.png'

const FOOTER_COL1 = [
  { label: 'Terms and Conditions', href: '/terms' },
  { label: 'Merchant Terms', href: '/merchant-terms' },
  { label: 'Acceptable Use Policy', href: '/acceptable-use' },
]

const FOOTER_COL2 = [
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Cookie Policy', href: '/cookies' },
  { label: 'Dispute Resolution', href: '/dispute-resolution' },
  { label: 'Support', href: 'mailto:support@askdecida.com', external: true },
]

function NavLink({ label, href, external }) {
  if (external) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm text-gray-400 hover:text-white transition-colors duration-200"
      >
        {label}
      </a>
    )
  }
  return (
    <Link
      to={href}
      className="text-sm text-gray-400 hover:text-white transition-colors duration-200"
    >
      {label}
    </Link>
  )
}

export default function Footer() {
  return (
    <footer className="bg-brand-dark text-white">
      <div className="section-container py-14">

        <div className="flex flex-col md:flex-row md:items-start
                        md:justify-between gap-10">

          {/* ── Brand ───────────────────────────────── */}
          <div className="max-w-xs">
            <div className="inline-block rounded-2xl shadow-sm">
              <img src={logo} alt="DecidA" className="w-36 h-auto" />
              <p className="text-sm text-gray-400 leading-relaxed">
                Stop asking around. Ask DecidA.
              </p>
            </div>
          </div>

          {/* ── Links — two columns ─────────────────── */}
          <nav
            className="grid grid-cols-2 gap-x-12 gap-y-3"
            aria-label="Footer navigation"
          >
            {FOOTER_COL1.map((link) => (
              <NavLink key={link.label} {...link} />
            ))}
            {FOOTER_COL2.map((link) => (
              <NavLink key={link.label} {...link} />
            ))}
          </nav>
        </div>

        {/* Brand line */}
        <div className="mt-10 pt-8 border-t border-white/10 text-center">
          <p className="text-base font-semibold text-white/40 mb-1 tracking-tight">
            <span className="line-through decoration-accent/50 decoration-2 text-white/20">
              "Who knows someone?"
            </span>
          </p>
          <p className="text-xl font-extrabold text-white mb-6 tracking-tight">
            Ask DecidA.
          </p>
          <p className="text-xs text-gray-600">
            © {new Date().getFullYear()} DecidA LLC. All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  )
}
